import debounce from 'lodash.debounce';
import queryString from 'querystring';

class SearchPage {
  constructor(indexName) {
    this.indexName = indexName;

    // Elements
    this.scrollOffset = document.getElementById('search-results');
    this.results = document.querySelector('.search__results');
    this.resultsWrapper = document.querySelector('.search__results-wrapper');
    this.filtersButton = document.querySelector('.search__filters-toggle');
    this.allFilters = document.querySelector('.search__results--left');
    this.searchToast = document.querySelector('.js--search-toast');
    this.searchInputClassName = 'search__input';

    // Booleans
    this.isSearching = false;
    this.filterDrawerOpen = false;

    // Event listeners
    this.filtersButton.addEventListener('click', () => this.toggleFilters());
    this.searchToast.addEventListener('click', this.scrollToast.bind(this));
    window.addEventListener('resize', () => this.checkWidth(this.mq));

    this.mq = window.matchMedia('(min-width: 768px)');
    this.toastActive = debounce(this.updateToast, 100);
    this.hitsPerPage = 20;

    this.blogId = parseInt(document.body.dataset.blogId, 10);
    this.blogName = document.body.dataset.blogName;

    this.checkWidth(this.mq);
  }

  get isMainSite() {
    return this.blogId === 1;
  }

  get queryParam() {
    const urlParams = queryString.parse(decodeURIComponent(window.location.search));

    if (JSON.stringify(urlParams) === '{}') {
      return null;
    }

    const plainQueryParam = urlParams.query;
    const bracketedQueryParam = urlParams[`?${this.indexName}[query]`];

    if (plainQueryParam) {
      return plainQueryParam;
    } else if (bracketedQueryParam) {
      return bracketedQueryParam;
    }

    return null;
  }

  toggleHide(el, condition) {
    el.classList.toggle('hide', condition);
  }

  checkWidth(mq) {
    if (mq.matches) {
      this.enableFilters();
    } else {
      this.disableFilters();
    }
  }

  toggleFilters() {
    if (this.filterDrawerOpen) {
      this.closeFilters();
    } else {
      this.openFilters();
    }
  }

  openFilters() {
    this.filterDrawerOpen = true;
    this.filtersButton.innerHTML = 'Hide Filters';
    this.allFilters.classList.remove('hide');
  }

  closeFilters() {
    this.filterDrawerOpen = false;
    this.filtersButton.innerHTML = 'Show Filters';
    this.allFilters.classList.add('hide');
  }

  enableFilters() {
    this.openFilters();
    this.filtersButton.classList.add('hide');
  }

  disableFilters() {
    this.closeFilters();
    this.filtersButton.classList.remove('hide');
  }

  refinementItemTemplate(item) {
    const { label, value, count, isRefined } = item;
    return `
      <label class="ais-RefinementList-label">
        <input
          type="checkbox"
          class="ais-RefinementList-checkbox"
          value="${value}"
          ${isRefined ? 'checked' : ''}>
        <span class="ais-RefinementList-labelText">${label}</span>
        <span class="ais-RefinementList-count">${count}</span>
      </label>
    `;
  }

  scrollToast(e) {
    e.preventDefault();
    const x = this.scrollOffset.getBoundingClientRect().top + window.scrollY;
    window.scrollTo(0, x - 40);
  }

  updateToast() {
    if (!this.isSearching) {
      this.isSearching = true;
      this.searchToast.classList.add('search-is-active');

      setTimeout(() => {
        this.searchToast.classList.remove('search-is-active');
        this.isSearching = false;
      }, 2000);
    }
  }

  updateRefListClasses(items, refList) {
    // Add a class to a refinement list if any have been applied
    const hasRefinement = items.some(item => item.isRefined);
    hasRefinement ? refList.classList.add('is-refined') : refList.classList.remove('is-refined');
  }

  // Alphabetically sort refinements by name using the sortBy param
  alphaSortRefinements(a, b) {
    return a.name < b.name ? -1 : a.name > b.name ? 1 : 0;
  }
}

export default SearchPage;
